import { render, staticRenderFns } from "./Amortization.vue?vue&type=template&id=ed4debd0&scoped=true"
import script from "./Amortization.vue?vue&type=script&lang=js"
export * from "./Amortization.vue?vue&type=script&lang=js"
import style0 from "./Amortization.vue?vue&type=style&index=0&id=ed4debd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4debd0",
  null
  
)

export default component.exports